import React from "react";
import { useSelector } from "react-redux";
import { authContext, AuthState } from './auth';
import { selectAccessToken, selectAuthStatus, AuthStatus } from "./authSlice";

function getAuthState(accessToken: string | null, authStatus: AuthStatus) {
  if (authStatus === "succeeded") {
    return accessToken ? AuthState.SignedIn : AuthState.SignedOut;
  } else if (authStatus === "failed") {
    return AuthState.SignedOut;
  } else if (authStatus === "loading") {
    return AuthState.Loading;
  } else {
    return AuthState.Idle;
  }
}

function useProvideAuth() {
  const accessToken = useSelector(selectAccessToken);
  const authStatus = useSelector(selectAuthStatus);
  const authState = getAuthState(accessToken, authStatus);
  return {
    authToken: accessToken,
    state: authState,
  };
}

export interface ProvideAuthProps {
  children: React.ReactNode
};

const ProvideAuth = ({ children }: ProvideAuthProps) => {
  const auth = useProvideAuth();
  return (
    <authContext.Provider value={auth}>
      {children}
    </authContext.Provider>
  );
};

export default ProvideAuth;